import safelyGetSmartReplyExtractionId from './safelyGetSmartReplyExtractionId';
import { ComposeViewState, ComposeOperation } from 'owa-mail-compose-store';
import { AttachmentFileType } from 'owa-attachment-file-types';
import { logUsage } from 'owa-analytics';
import { getSharingLinkInfo, SharingLinkInfo } from 'owa-link-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export function logAttachmentDatapoints(viewState: ComposeViewState) {
    // Attachment Count Information
    let classicAttachmentCount: number;
    let cloudyAttachmentCount: number;
    let linkInBodyCount: number;
    let ODSPLinkInBodyCount: number;
    let smartDocCount: number;
    // attachmentWell and allAttachments are not typecast to avoid uneccesary imports into this package
    const attachmentWell = viewState.attachmentWell;
    if (attachmentWell) {
        const allAttachments: any[] = attachmentWell.docViewAttachments.concat(
            attachmentWell.imageViewAttachments
        );

        // Cosmos only logs datapoints if each custom data field has at most 24 unique values.
        // We expect more than 23 attachments/links in body to be a rare situation, so we round down to 23
        // in this case to preserve the rest of the data.
        classicAttachmentCount = Math.min(
            allAttachments.filter(attachment => !attachment.isCloudy).length,
            23
        );
        cloudyAttachmentCount = Math.min(
            allAttachments.filter(attachment => attachment.isCloudy).length,
            23
        );

        ODSPLinkInBodyCount = attachmentWell.sharingLinkIds.filter(id => {
            const sharingLink: SharingLinkInfo = getSharingLinkInfo(id);
            return sharingLink?.providerType === AttachmentDataProviderType.OneDrivePro;
        }).length;

        ODSPLinkInBodyCount = Math.min(ODSPLinkInBodyCount, 23);

        linkInBodyCount = Math.min(attachmentWell.sharingLinkIds.length, 23);

        smartDocCount = Math.min(
            allAttachments.filter(attachment => attachment.fileType == AttachmentFileType.SmartDoc)
                .length,
            23
        );
    }

    // Compose Operation Type Information
    const operation: ComposeOperation = viewState.operation;
    const isReply: boolean =
        operation == ComposeOperation.Reply || operation == ComposeOperation.ReplyAll;

    // Reference Item Id of the Previous Email, undefined if not reply/forward.
    const referenceItemId: string = viewState.referenceItemId?.Id;

    logUsage(
        'AttachmentCountsOnMessageSent',
        [
            classicAttachmentCount,
            linkInBodyCount,
            cloudyAttachmentCount,
            smartDocCount,
            ODSPLinkInBodyCount,
        ],
        {
            cosmosOnlyData: JSON.stringify([
                {
                    smartDocExtractionId: safelyGetSmartReplyExtractionId(
                        viewState,
                        'smartDoc' /* type */
                    ),
                    isReply: isReply,
                    referenceItemId: referenceItemId,
                },
            ]),
            isCore: true,
            isCosmosDatapoint: true, // only log this datapoint to Cosmos and not to Aria to avoid over-populating Aria
        }
    );
}
